<template>
  <div>
    <div class="p-box">
      <div class="p-box__body">
        <ValidationObserver v-slot="{ handleSubmit }">
          <form v-show="!loading" @submit.prevent="handleSubmit($event, onSubmit)">
            <ValidationProvider v-slot="{ errors, value, handleChange }" v-model="name" :name="$t('models.area.areaName')" rules="required">
              <label class="c-formLabel">{{ $t('models.area.areaName') }}</label>
              <span v-for="error in errors" :key="error" class="c-error-msg">
                {{ error }}
              </span>
              <TextField :value="value" class="c-textField" :placeholder="$t('labels.placeholder.enter', { value: $t('models.area.areaName') })" @input="handleChange" />
            </ValidationProvider>
            <div class="c-button c-button--right">
              <router-link class="c-button__item c-button__item--outline-cancel" :to="{ name: 'CompaniesManagementAreas', params: { company_uuid: currentCompanyUuid } }">{{ $t('labels.cancel') }}</router-link>
              <button class="c-button__item c-button__item--primary">
                {{ $t('labels.save') }}
              </button>
            </div>
          </form>
        </ValidationObserver>
      </div>
      <Loading v-show="loading" />
    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import Loading from '../components/Loading'
import TextField from '../components/TextField'

export default {
  components: {
    Loading,
    TextField,
  },
  data() {
    return {
      name: '',
    }
  },
  computed: {
    ...mapState({
      area: state => state.companiesArea.data,
      loading: state => state.companiesArea.loading,
      errors: state => state.companiesArea.errors,
    }),
    currentCompanyUuid() {
      return this.$route.params.company_uuid
    },
    currentAreaId() {
      return this.$route.params.area_id
    },
  },
  watch: {
    errors: function (val) {
      this.$updateFlash({ type: 'alert', message: val })
    }
  },
  async created() {
    if (this.currentAreaId) {
      await this.readArea({ company_uuid: this.currentCompanyUuid, area_id: this.currentAreaId })
      this.name = this.area.attributes.name
    }
  },
  methods: {
    ...mapActions({
      readArea: 'companiesArea/readArea',
      createArea: 'companiesArea/createArea',
      updateArea: 'companiesArea/updateArea',
    }),
    async onSubmit() {
      const payload = {
        name: this.name,
      }
      await this.submitApi(payload)
      if (!this.errors) {
        this.$router.push({ name: 'CompaniesManagementAreas', params: { company_uuid: this.currentCompanyUuid } })
      }
    },
    submitApi(payload) {
      if (this.currentAreaId) {
        return this.updateArea({ company_uuid: this.currentCompanyUuid, area_id: this.currentAreaId, payload: payload })
      } else {
        return this.createArea({ company_uuid: this.currentCompanyUuid, payload: payload })
      }
    }
  },
}
</script>
<style lang="scss" scoped>
</style>
